module.exports = __webpack_public_path__ + "static/img/app_store.e82fbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iapp/app_store.png
// module id = 561
// module chunks = 0